// extracted by mini-css-extract-plugin
export var childrenContainer = "_bp-0";
export var virtualScrollArea = "_bp-1";